import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // SweetAlert2 for notifications
import ClipLoader from "react-spinners/ClipLoader"; // Loading spinner
import apiService from "../../api/auth/auth"; // API service for registration
import "./../../css/signup.css";

export default function App() {
  const navigate = useNavigate(); // Navigation function
  const [values, setValues] = useState({
    username: "",
    name: "",
    phoneNumber: "",
    email: "",
    password: "",
    profilePicture: null,
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value, type, files } = event.target;

    if (type === "file") {
      const reader = new FileReader();
      reader.onloadend = () => {
        setValues((prevValues) => ({
          ...prevValues,
          profilePicture: reader.result,
        }));
      };
      if (files[0]) {
        reader.readAsDataURL(files[0]);
      }
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (values.username && values.name && values.email && values.password && values.profilePicture) {
      setLoading(true); // Set loading to true
      try {
        const payload = {
          id: "",
          username: values.username,
          name: values.name,
          phoneNumber: values.phoneNumber,
          email: values.email,
          password: values.password,
          profilePicture: values.profilePicture,
        };

        const response = await apiService.registerUser(payload);

        if (response && response.id) {
          setLoading(false); // Stop loading
          Swal.fire({
            icon: "success",
            title: "Registration Successful",
            text: `Welcome, ${values.name}! Your account has been created.`,
            confirmButtonText: "OK",
          }).then(() => navigate("/Login"));
        }
      } catch (error) {
        setLoading(false); // Stop loading
        Swal.fire({
          icon: "error",
          title: "Registration Failed",
          text: "There was an error registering your account. Please try again.",
        });
        console.error("Registration Error:", error);
      }
    } else {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Form",
        text: "Please fill out all the required fields.",
      });
    }
  };

  return (
    <div className="signup-page">
      <div className="form-container">
        {loading ? ( // Show spinner while loading
          <div className="loading-spinner">
            <ClipLoader color="#007BFF" size={60} /> {/* Blue spinner */}
            <p>Submitting your information...</p>
          </div>
        ) : (
          <form className="register-form" onSubmit={handleSubmit}>
            <h2>Create Account</h2>

            <input
              className="form-field"
              type="text"
              placeholder="Username"
              name="username"
              value={values.username}
              onChange={handleInputChange}
            />

            <input
              className="form-field"
              type="text"
              placeholder="Full Name"
              name="name"
              value={values.name}
              onChange={handleInputChange}
            />

            <input
              className="form-field"
              type="email"
              placeholder="Email"
              name="email"
              value={values.email}
              onChange={handleInputChange}
            />

            <input
              className="form-field"
              type="text"
              placeholder="Phone Number"
              name="phoneNumber"
              value={values.phoneNumber}
              onChange={handleInputChange}
            />

            <input
              className="form-field"
              type="password"
              placeholder="Password"
              name="password"
              value={values.password}
              onChange={handleInputChange}
            />

            <input
              className="form-field"
              type="file"
              placeholder="Profile Picture"
              name="profilePicture"
              onChange={handleInputChange}
            />

            <button className="form-field" type="submit">
              Register
            </button>

            <div className="already-registered">
              <span>Already have an account? <a href="/Login">Login here</a></span>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
